/* Albisia: site scripts. Loaded once and cached, deferred until the page is parsed. */

// Home page and site-wide touches: the hero words, the Bonded glass card, the scroll cue, the pile, the studio photographs, the floating header.
(function () {
  function split() {
    var t = document.querySelector('[id$="__slideshow_UpwPUW"] .hero__title .animation-contents') || document.querySelector('[id$="__slideshow_UpwPUW"] .hero__title');
    if (!t || t.querySelector('.alb-w')) return;
    var words = t.textContent.replace(/\s+/g, ' ').trim().split(' ');
    if (words.length < 2) return;
    t.textContent = '';
    words.forEach(function (wd, i) {
      var s = document.createElement('span'); s.className = 'alb-w' + (i === 1 ? ' alb-w--accent' : ''); s.textContent = wd; t.appendChild(s);
      if (i < words.length - 1) t.appendChild(document.createTextNode(' '));
    });
  }
  function splitSub() {
    var s = document.querySelector('[id$="__slideshow_UpwPUW"] .hero__subtitle .animation-contents') || document.querySelector('[id$="__slideshow_UpwPUW"] .hero__subtitle');
    if (!s || s.querySelector('.alb-line')) return;
    var txt = s.textContent.replace(/\s+/g, ' ').trim();
    var i = txt.indexOf(', ');
    if (i < 0) return;
    s.textContent = '';
    [txt.slice(0, i + 1), txt.slice(i + 2)].forEach(function (line) { var el = document.createElement('span'); el.className = 'alb-line'; el.textContent = line; s.appendChild(el); });
  }
  // Bonded for Life: wrap the words in a glass card, light the last word, add the "learn more" button, and let the chains ease forward on arrival.
  function bonded() {
    var sec = document.querySelector('[id$="__slideshow_WVfH4T"]');
    if (!sec) return;
    var tc = sec.querySelector('.hero__text-content');
    if (tc && !tc.querySelector('.alb-glass')) {
      var glass = document.createElement('div'); glass.className = 'alb-glass';
      while (tc.firstChild) glass.appendChild(tc.firstChild);
      tc.appendChild(glass);
    }
    var t = sec.querySelector('.hero__title .animation-contents') || sec.querySelector('.hero__title');
    if (t && !t.querySelector('.alb-w')) {
      var words = t.textContent.replace(/\s+/g, ' ').trim().split(' ');
      t.textContent = '';
      words.forEach(function (wd, i) { var s = document.createElement('span'); s.className = 'alb-w' + (i === words.length - 1 ? ' alb-w--accent' : ''); s.textContent = wd; t.appendChild(s); if (i < words.length - 1) t.appendChild(document.createTextNode(' ')); });
    }
    var link = sec.querySelector('.hero__link');
    if (link && !sec.querySelector('.alb-btn--ghost')) {
      var a = document.createElement('a'); a.className = 'btn alb-btn--ghost'; a.href = '/pages/albisia-sparked-collection'; a.textContent = 'How it works';
      if (link.tagName === 'A') { var wrap = document.createElement('div'); wrap.className = 'alb-actions'; link.parentNode.insertBefore(wrap, link); wrap.appendChild(a); wrap.appendChild(link); }
      else link.insertBefore(a, link.firstChild);
    }
    // One quiet line under the buttons for groups: opens the party form.
    var host = sec.querySelector('.alb-actions') || sec.querySelector('.hero__link');
    if (host && !sec.querySelector('.alb-partyline')) {
      var pl = document.createElement('a'); pl.className = 'alb-partyline'; pl.href = '/pages/sparked-parties#book-party'; pl.textContent = 'Five or more? Plan a party';
      pl.style.cssText = 'display:inline-block;margin-top:16px;font-family:Montserrat,Helvetica,Arial,sans-serif;font-size:10.5px;letter-spacing:2.5px;text-transform:uppercase;color:#6F6F6F;text-decoration:none;border-bottom:1px solid currentColor;padding-bottom:2px';
      host.parentNode.insertBefore(pl, host.nextSibling);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { sec.classList.add('alb-inview'); io.disconnect(); } }, { threshold: .25 });
      io.observe(sec);
    } else sec.classList.add('alb-inview');
  }
  // The scroll cue, and Safari's tab colour: white to match the bar above the header.
  function cue() {
    var sec = document.querySelector('[id$="__slideshow_UpwPUW"]');
    var hero = sec;
    if (!hero || hero.querySelector('.alb-scroll')) return;
    var a = document.createElement('a'); a.className = 'alb-scroll'; a.href = '#'; a.setAttribute('aria-label', 'Scroll to the collection');
    a.innerHTML = '<span class="alb-scroll__line"></span>';
    a.addEventListener('click', function (e) { e.preventDefault(); var next = sec.nextElementSibling; if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    hero.appendChild(a);
  }
  if (!document.querySelector('meta[name="theme-color"]')) { var mt = document.createElement('meta'); mt.name = 'theme-color'; mt.content = '#FFFFFF'; document.head.appendChild(mt); }
  // The One Collection pile: the fifth picture (pearl earrings on blue) takes the big top spot, the first takes its place.
  function pile() {
    var sec = document.querySelector('[id$="__collection_callout_PJxGr3"]');
    if (!sec || sec.dataset.albPiled) return;
    var a = sec.querySelector('.callout-image--1'), b = sec.querySelector('.callout-image--5');
    var ia = a && (a.tagName === 'IMG' ? a : a.querySelector('img')), ib = b && (b.tagName === 'IMG' ? b : b.querySelector('img'));
    if (!ia || !ib) return;
    ['src', 'srcset', 'data-src', 'data-srcset', 'alt'].forEach(function (k) {
      var va = ia.getAttribute(k), vb = ib.getAttribute(k);
      if (va === null && vb === null) return;
      if (vb === null) ia.removeAttribute(k); else ia.setAttribute(k, vb);
      if (va === null) ib.removeAttribute(k); else ib.setAttribute(k, va);
    });
    sec.dataset.albPiled = '1';
  }
  // Studio: photographs of the studio crossfade behind the card. Tall ones on phones, wide ones on larger screens. Fetched only once the section is a screen away.
  function studio() {
    var sec = document.querySelector('[id$="__map_visit"]');
    if (!sec || sec.dataset.albStudio) return;
    sec.dataset.albStudio = '1';
    var build = function () {
      if (sec.querySelector('.alb-studio')) return;
      var base = 'https://cdn.shopify.com/s/files/1/0281/1316/files/';
      var tall = window.matchMedia('(max-width: 768px)').matches;
      var size = tall ? 900 : (window.innerWidth > 1600 ? 2000 : 1600);
      var list = tall ? ['albisia-studio-tall-1.jpg', 'albisia-studio-tall-2.jpg', 'albisia-studio-tall-3.jpg'] : ['albisia-studio-wide-1.jpg', 'Albisia_Jan_2023--7.jpg'];
      var wrap = document.createElement('div'); wrap.className = 'alb-studio' + (list.length === 2 ? ' alb-studio--2' : '');
      wrap.style.backgroundImage = 'url(' + base + list[0] + '?width=' + size + ')'; wrap.style.backgroundSize = 'cover'; wrap.style.backgroundPosition = 'center';
      list.forEach(function (n, i) { var d = document.createElement('div'); d.className = 'alb-studio__slide'; d.style.backgroundImage = 'url(' + base + n + '?width=' + size + ')'; d.style.animationDelay = (i * 8) + 's'; wrap.appendChild(d); });
      var host = sec.querySelector('.map-section') || sec;
      host.insertBefore(wrap, host.firstChild);
    };
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { build(); io.disconnect(); } }, { rootMargin: '100% 0px' }); io.observe(sec); }
    else build();
  }
  // Header: once the page has scrolled a little, the bar turns to floating glass, as wide as the content.
  function stuck() {
    var h = document.getElementById('HeaderWrapper'); if (!h) return;
    if (!h.dataset.albBarW) { var pw = h.querySelector('.site-header > .page-width'); var mw = pw ? getComputedStyle(pw).maxWidth : ''; h.dataset.albBarW = mw && mw !== 'none' ? mw : '1400px'; h.style.setProperty('--alb-bar-w', h.dataset.albBarW); }
    h.classList.toggle('alb-stuck', (window.scrollY || document.documentElement.scrollTop) > 60);
  }
  window.addEventListener('scroll', stuck, { passive: true }); stuck();
  split(); splitSub(); bonded(); cue(); pile(); studio();
  document.addEventListener('shopify:section:load', function () { split(); splitSub(); bonded(); cue(); pile(); studio(); stuck(); });
})();

// The booking popup, the quote form, the Sparked party request, the made-to-order and one-of-a-kind blocks on product pages.
(function () {
  var root = document.querySelector('[data-albisia-booking]');
  if (!root) return;
  var API = root.getAttribute('data-api');
  var LIVE = root.getAttribute('data-live') === 'true';
  var TS_KEY = root.getAttribute('data-turnstile') || '';
  var panel = root.querySelector('.alb-book__panel');
  var body = root.querySelector('[data-book-body]');
  var titleEl = root.querySelector('[data-book-title]');
  var subEl = root.querySelector('[data-book-sub]');
  var statusEl = root.querySelector('[data-book-status]');
  var ADDRESS = '1605 W Snow Circle, Hyde Park Village, Tampa, FL 33606';
  var TZ = 'America/New_York';
  var DESC = {
    sparked: 'Welded-on gold, measured and fitted in person at the studio. About fifteen minutes.',
    repair: 'A quick fix for an Albisia piece, done in the studio.',
    showroom: 'Come to Hyde Park Village to see stones and talk through a design. Thirty minutes.',
    virtual: 'The same conversation over video, wherever you are. Thirty minutes.'
  };
  var TITLE = { sparked: 'Book a Sparked session', repair: 'Book a repair session', showroom: 'Book a showroom appointment', virtual: 'Book a virtual appointment' };
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOWS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

  var S = { services: null, service: null, month: null, days: {}, date: null, slots: [], slot: null, party: 1, lastFocus: null, open: false, turnstile: '', piece: null, only: null, mode: 'book', party_pkg: '' };
  var pieceFromPage = function () { var el = document.querySelector('[data-albisia-piece]'); return el ? { title: el.getAttribute('data-title') || '', sku: el.getAttribute('data-sku') || '', url: el.getAttribute('data-url') || '' } : null; };
  var whereText = function (svc) { return svc.location_type === 'video' ? 'By video' : svc.location_type === 'phone' ? 'By phone' : 'At the studio, Hyde Park Village'; };
  var metaText = function (svc) { return svc.duration_min + ' min · ' + whereText(svc) + ' · No charge to book'; };
  var imgUrl = function (svc, size) { return svc.image_url ? svc.image_url + (svc.image_url.indexOf('?') > -1 ? '&' : '?') + 'width=' + size + '&height=' + size + '&crop=center' : ''; };
  var partyQuestion = function (svc) { return ((svc && svc.questions) || []).find(function (q) { return q.role === 'party_size'; }) || null; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var fmtDate = function (iso) { return new Intl.DateTimeFormat('en-US', { timeZone: TZ, weekday: 'long', month: 'long', day: 'numeric' }).format(new Date(iso)); };
  var fmtTime = function (iso) { return new Intl.DateTimeFormat('en-US', { timeZone: TZ, hour: 'numeric', minute: '2-digit' }).format(new Date(iso)); };
  var todayTampa = function () { var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; }); return p.year + '-' + p.month + '-' + p.day; };

  function setStatus(msg, isError) { statusEl.textContent = msg || ''; statusEl.classList.toggle('is-error', !!isError); }
  function setHead(title, sub) { titleEl.textContent = title; if (sub) { subEl.textContent = sub; subEl.hidden = false; } else { subEl.hidden = true; } }

  async function api(path) {
    var res = await fetch(API + path, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json();
  }

  var CACHE_KEY = 'albisia-booking-services-v1';
  async function loadServices() {
    if (S.services) return S.services;
    try { var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); if (c && c.t && Date.now() - c.t < 600000 && c.services) { S.services = c.services; return S.services; } } catch (e) {}
    var data = await api('/availability?services=1');
    S.services = data.services || [];
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), services: S.services })); } catch (e) {}
    return S.services;
  }
  // Warm the service list and the pictures shortly after the page loads, so the popup opens without a wait.
  function warm() {
    loadServices().then(function (svcs) {
      svcs.forEach(function (s) { [160, 220].forEach(function (size) { var u = imgUrl(s, size); if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; } }); });
    }).catch(function () {});
  }

  // ---------------- open / close ----------------
  async function open(opts) {
    opts = opts || {};
    S.lastFocus = document.activeElement;
    S.service = null; S.date = null; S.slot = null; S.slots = []; S.days = {}; S.party = 1;
    S.piece = opts.piece || null; S.only = opts.only || null; S.mode = opts.mode === 'quote' ? 'quote' : opts.mode === 'party' ? 'party' : 'book';
    root.hidden = false; S.open = true;
    panel.classList.toggle('alb-book__panel--wide', S.mode === 'party');
    document.documentElement.style.overflow = 'hidden';
    setHead('Book an appointment', '');
    setStatus('Loading');
    body.innerHTML = '';
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
    if (S.mode === 'quote') { setStatus(''); showQuote(); return; }
    if (S.mode === 'party') { setStatus(''); showParty(opts.pkg || '', opts.occasion || ''); return; }
    try {
      var services = await loadServices();
      var svc = null;
      if (opts.service) svc = services.find(function (s) { return s.key === opts.service; });
      if (!svc && opts.variantId) svc = services.find(function (s) { return String(s.shopify_variant_id) === String(opts.variantId); });
      setStatus('');
      if (svc) { S.service = svc; await showDates(); }
      else showServices();
    } catch (e) {
      showFallback();
    }
  }
  function close() {
    root.hidden = true; S.open = false;
    document.documentElement.style.overflow = '';
    if (S.lastFocus && S.lastFocus.focus) S.lastFocus.focus();
  }

  // ---------------- steps ----------------
  function showServices() {
    setHead('Book an appointment', S.piece && S.piece.title ? 'About ' + S.piece.title + '. Choose how you would like to talk it through.' : 'Every piece starts with a conversation. Choose how you would like to have it.');
    var list = S.services.filter(function (s) { return !S.only || S.only.indexOf(s.key) > -1; });
    if (!list.length) list = S.services;
    var items = list.map(function (s) {
      return '<li class="alb-book__item"><button type="button" class="alb-book__option" data-pick-service="' + esc(s.key) + '">' +
        (imgUrl(s, 160) ? '<img class="alb-book__thumb" src="' + esc(imgUrl(s, 160)) + '" alt="" decoding="async" fetchpriority="high">' : '') +
        '<span><span class="alb-book__option-label">' + esc(s.name) + '</span>' +
        ((s.description || DESC[s.key]) ? '<span class="alb-book__option-desc">' + esc(s.description || DESC[s.key]) + '</span>' : '') +
        '<span class="alb-book__meta">' + esc(metaText(s)) + '</span></span>' +
        '<span class="alb-book__arrow" aria-hidden="true">&rarr;</span></button></li>';
    }).join('');
    // A Sparked party is not a service on the calendar; it is a request. It sits last in the chooser unless the chooser was narrowed (product pages).
    if (!S.only) items += '<li class="alb-book__item"><button type="button" class="alb-book__option" data-pick-service="__party">' +
      '<span><span class="alb-book__option-label">Sparked party</span>' +
      '<span class="alb-book__option-desc">Permanent jewelry for a group of five or more, with an artist dedicated to your table.</span>' +
      '<span class="alb-book__meta">By request · At the studio, Hyde Park Village · No charge to book</span></span>' +
      '<span class="alb-book__arrow" aria-hidden="true">&rarr;</span></button></li>';
    body.innerHTML = '<ul class="alb-book__list">' + items + '</ul>';
    var first = body.querySelector('button'); if (first) first.focus();
  }

  async function showDates(monthKey) {
    var svc = S.service;
    setHead(TITLE[svc.key] || ('Book: ' + svc.name), '');
    if (!monthKey) monthKey = S.month || todayTampa().slice(0, 7);
    S.month = monthKey;
    setStatus('Loading days');
    var days;
    try {
      if (!S.days[monthKey]) { var d = await api('/availability?service=' + encodeURIComponent(svc.key) + '&month=' + monthKey); S.days[monthKey] = d.days || []; }
      days = S.days[monthKey];
    } catch (e) { showFallback(); return; }
    setStatus('');
    var y = +monthKey.slice(0, 4), m = +monthKey.slice(5, 7);
    var first = new Date(Date.UTC(y, m - 1, 1));
    var startDow = first.getUTCDay();
    var dim = new Date(Date.UTC(y, m, 0)).getUTCDate();
    var today = todayTampa();
    var thisMonth = today.slice(0, 7);
    var maxMonth = (function () { var t = new Date(); t.setUTCMonth(t.getUTCMonth() + Math.ceil((svc.horizon_days || 120) / 30)); return t.toISOString().slice(0, 7); })();
    var cells = '';
    for (var i = 0; i < startDow; i++) cells += '<button type="button" class="alb-book__day is-empty" tabindex="-1" aria-hidden="true"></button>';
    for (var d = 1; d <= dim; d++) {
      var ds = monthKey + '-' + pad(d);
      var ok = days.indexOf(ds) > -1;
      cells += '<button type="button" class="alb-book__day" data-day="' + ds + '"' + (ok ? '' : ' disabled') + ' aria-label="' + esc(MONTHS[m - 1] + ' ' + d + (ok ? ', available' : ', unavailable')) + '" aria-pressed="' + (S.date === ds ? 'true' : 'false') + '">' + d + '</button>';
    }
    var hero = '<div class="alb-book__hero">' + (imgUrl(svc, 220) ? '<img src="' + esc(imgUrl(svc, 220)) + '" alt="" decoding="async" fetchpriority="high">' : '') +
      '<div><p>' + esc(svc.description || DESC[svc.key] || '') + '</p><span class="alb-book__meta">' + esc(metaText(svc)) + '</span></div></div>';
    body.innerHTML = hero +
      '<div class="alb-book__month">' +
        '<button type="button" class="alb-book__nav" data-month="-1" aria-label="Previous month"' + (monthKey <= thisMonth ? ' disabled' : '') + '>&larr;</button>' +
        '<span class="alb-book__month-name" aria-live="polite">' + esc(MONTHS[m - 1] + ' ' + y) + '</span>' +
        '<button type="button" class="alb-book__nav" data-month="1" aria-label="Next month"' + (monthKey >= maxMonth ? ' disabled' : '') + '>&rarr;</button>' +
      '</div>' +
      '<div class="alb-book__grid" role="grid" aria-label="Choose a day">' + DOWS.map(function (x) { return '<div class="alb-book__dow" aria-hidden="true">' + x + '</div>'; }).join('') + cells + '</div>' +
      '<p class="alb-book__hint">Times are shown in Tampa time. ' + (days.length ? 'Pick a day to see open times.' : 'No open days this month.') + '</p>' +
      (S.services.length > 1 ? '<button type="button" class="alb-book__link" data-back="services">Choose a different appointment</button>' : '');
    var firstOk = body.querySelector('.alb-book__day:not(:disabled)');
    if (firstOk) firstOk.focus();
  }

  async function showTimes(ds) {
    var svc = S.service;
    S.date = ds; S.slot = null;
    var pq = partyQuestion(svc);
    setStatus('Loading times');
    try {
      var d = await api('/availability?service=' + encodeURIComponent(svc.key) + '&date=' + ds + (pq ? '&party=' + S.party : ''));
      S.slots = d.slots || [];
    } catch (e) { showFallback(); return; }
    setStatus('');
    var label = fmtDate(ds + 'T12:00:00Z');
    var maxParty = Math.max(1, Math.min(8, parseInt(svc.max_party, 10) || 6));
    var partyRow = (pq && maxParty > 1) ? '<div class="alb-book__party"><span class="alb-book__party-label" id="alb-party-label">' + esc(pq.label) + '</span><div class="alb-book__party-row" role="group" aria-labelledby="alb-party-label">' +
      Array.from({ length: maxParty }, function (_, i) { return i + 1; }).map(function (n) { return '<button type="button" class="alb-book__party-btn" data-party="' + n + '" aria-pressed="' + (n === S.party ? 'true' : 'false') + '">' + n + '</button>'; }).join('') + '</div></div>' : '';
    body.innerHTML =
      '<div class="alb-book__summary"><b>' + esc(svc.name) + '</b>' + esc(label) + '</div>' + partyRow +
      (S.slots.length ? '<div class="alb-book__times" role="group" aria-label="Open times">' + S.slots.map(function (s) { return '<button type="button" class="alb-book__time" data-slot="' + esc(s.start) + '">' + esc(s.label) + '</button>'; }).join('') + '</div>'
        : '<p class="alb-book__hint">' + (pq && S.party > 1 ? 'No times left that day for ' + S.party + ' people. Try a smaller group or another day.' : 'No open times left that day.') + '</p>') +
      '<button type="button" class="alb-book__link" data-back="dates">Change the day</button>';
    var first = body.querySelector('.alb-book__time'); if (first) first.focus(); else body.querySelector('[data-back]').focus();
  }

  function showDetails(startIso) {
    var svc = S.service;
    S.slot = S.slots.find(function (s) { return s.start === startIso; }) || { start: startIso };
    var phoneReq = svc.key === 'virtual';
    var pq = partyQuestion(svc);
    var q = (svc.questions || []).filter(function (x) { return !pq || x.id !== pq.id; }).map(function (x) {
      var id = 'alb-q-' + x.id;
      var field;
      if (x.type === 'select') field = '<select class="alb-book__field" id="' + id + '" name="q_' + esc(x.id) + '"' + (x.required ? ' required' : '') + '><option value="">Choose</option>' + (x.options || []).map(function (o) { return '<option value="' + esc(o) + '">' + esc(o) + '</option>'; }).join('') + '</select>';
      else if (x.type === 'number') field = '<input class="alb-book__field" id="' + id + '" name="q_' + esc(x.id) + '" type="number" min="1" max="20" inputmode="numeric"' + (x.required ? ' required' : '') + '>';
      else field = '<input class="alb-book__field" id="' + id + '" name="q_' + esc(x.id) + '" type="text" maxlength="200"' + (x.required ? ' required' : '') + '>';
      return '<label for="' + id + '">' + esc(x.label) + (x.required ? ' (required)' : ' (optional)') + '</label>' + field;
    }).join('');
    body.innerHTML =
      '<div class="alb-book__summary"><b>' + esc(svc.name) + '</b>' + esc(fmtDate(S.slot.start)) + ' at ' + esc(fmtTime(S.slot.start)) + (pq && S.party > 1 ? ' for ' + S.party + ' people' : '') + (S.piece && S.piece.title ? '<br>About: ' + esc(S.piece.title) : '') + '</div>' +
      '<form data-book-form novalidate>' +
        '<label for="alb-name">Name (required)</label><input class="alb-book__field" id="alb-name" name="name" type="text" autocomplete="name" required>' +
        '<label for="alb-email">Email (required)</label><input class="alb-book__field" id="alb-email" name="email" type="email" autocomplete="email" inputmode="email" required>' +
        '<label for="alb-phone">Phone' + (phoneReq ? ' (required)' : ' (optional)') + '</label><input class="alb-book__field" id="alb-phone" name="phone" type="tel" autocomplete="tel" inputmode="tel"' + (phoneReq ? ' required' : '') + '>' +
        q +
        '<div class="alb-book__hp" aria-hidden="true"><label for="alb-website">Website</label><input id="alb-website" name="website" type="text" tabindex="-1" autocomplete="off"></div>' +
        '<label class="alb-book__check"><input type="checkbox" name="marketing_consent"> Send me new pieces and studio news by email (optional)</label>' +
        (TS_KEY ? '<div class="alb-book__turnstile" id="alb-turnstile" style="margin-top:14px"></div>' : '') +
        '<button type="submit" class="alb-book__btn">Confirm booking</button>' +
      '</form>' +
      '<button type="button" class="alb-book__link" data-back="times">Change the time</button>';
    body.querySelector('#alb-name').focus();
    if (TS_KEY) mountTurnstile();
  }

  function mountTurnstile() {
    S.turnstile = '';
    var go = function () { try { window.turnstile.render('#alb-turnstile', { sitekey: TS_KEY, size: 'flexible', theme: 'light', callback: function (t) { S.turnstile = t; }, 'expired-callback': function () { S.turnstile = ''; } }); } catch (e) {} };
    if (window.turnstile) { go(); return; }
    if (!document.querySelector('script[data-albisia-turnstile]')) {
      var s = document.createElement('script'); s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; s.async = true; s.defer = true; s.setAttribute('data-albisia-turnstile', '1');
      s.onload = go; document.head.appendChild(s);
    } else { var tries = 0; var t = setInterval(function () { if (window.turnstile || tries++ > 40) { clearInterval(t); if (window.turnstile) go(); } }, 250); }
  }

  async function submit(form) {
    var btn = form.querySelector('button[type="submit"]');
    var fd = new FormData(form);
    var answers = {};
    (S.service.questions || []).forEach(function (x) { var v = fd.get('q_' + x.id); if (v != null && String(v).trim() !== '') answers[x.id] = String(v).trim(); });
    var pqs = partyQuestion(S.service); if (pqs) answers[pqs.id] = String(S.party);
    var required = form.querySelectorAll('[required]');
    for (var i = 0; i < required.length; i++) { if (!String(required[i].value || '').trim()) { setStatus('Please fill in ' + String((form.querySelector('label[for="' + required[i].id + '"]') || {}).textContent || '').replace(' (required)', '') + '.', true); required[i].focus(); return; } }
    var email = String(fd.get('email') || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setStatus('Please enter a valid email.', true); form.querySelector('#alb-email').focus(); return; }
    if (TS_KEY && !S.turnstile) { setStatus('One moment, checking you are not a robot.', true); setTimeout(function () { if (S.turnstile) submit(form); }, 1500); return; }
    btn.disabled = true; setStatus('Confirming');
    try {
      var res = await fetch(API + '/book', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ service: S.service.key, start: S.slot.start, name: fd.get('name'), email: email, phone: fd.get('phone'), answers: answers, marketing_consent: !!fd.get('marketing_consent'), website: fd.get('website') || '', turnstile: S.turnstile || '', piece: S.piece || null }) });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok || !data.ok) {
        btn.disabled = false;
        setStatus(data.error || 'We could not confirm the booking. Please try again.', true);
        if (res.status === 409) { S.days = {}; setTimeout(function () { showTimes(S.date); }, 1200); }
        return;
      }
      showDone(data, email);
    } catch (e) {
      btn.disabled = false;
      setStatus('We could not reach the booking service. Please try again or email info@albisia.com.', true);
    }
  }

  // ---------------- request a quote ----------------
  function showQuote() {
    setHead('Request a quote', S.piece && S.piece.title ? S.piece.title + '. We will come back with a price and a timeline.' : 'Tell us what you have in mind and we will come back with a price and a timeline.');
    body.innerHTML =
      '<form data-quote-form novalidate>' +
        '<label for="alb-qname">Name (required)</label><input class="alb-book__field" id="alb-qname" name="name" type="text" autocomplete="name" required>' +
        '<label for="alb-qemail">Email (required)</label><input class="alb-book__field" id="alb-qemail" name="email" type="email" autocomplete="email" inputmode="email" required>' +
        '<label for="alb-qphone">Phone (optional)</label><input class="alb-book__field" id="alb-qphone" name="phone" type="tel" autocomplete="tel" inputmode="tel">' +
        '<label for="alb-qmsg">Anything we should know? (optional)</label><textarea class="alb-book__field" id="alb-qmsg" name="message" rows="3" maxlength="3000" placeholder="Size, stone, metal, a date you have in mind"></textarea>' +
        '<div class="alb-book__hp" aria-hidden="true"><label for="alb-qwebsite">Website</label><input id="alb-qwebsite" name="website" type="text" tabindex="-1" autocomplete="off"></div>' +
        '<label class="alb-book__check"><input type="checkbox" name="marketing_consent"> Send me new pieces and studio news by email (optional)</label>' +
        (TS_KEY ? '<div class="alb-book__turnstile" id="alb-turnstile" style="margin-top:14px"></div>' : '') +
        '<button type="submit" class="alb-book__btn">Send request</button>' +
      '</form>' +
      '<p class="alb-book__fine">Gold and stone prices move daily, so every piece is quoted fresh. We reply within one business day, usually sooner.</p>';
    body.querySelector('#alb-qname').focus();
    if (TS_KEY) mountTurnstile();
  }
  async function submitQuote(form) {
    var btn = form.querySelector('button[type="submit"]');
    var fd = new FormData(form);
    var name = String(fd.get('name') || '').trim(), email = String(fd.get('email') || '').trim();
    if (!name) { setStatus('Please fill in your name.', true); form.querySelector('#alb-qname').focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setStatus('Please enter a valid email.', true); form.querySelector('#alb-qemail').focus(); return; }
    if (TS_KEY && !S.turnstile) { setStatus('One moment, checking you are not a robot.', true); setTimeout(function () { if (S.turnstile) submitQuote(form); }, 1500); return; }
    btn.disabled = true; setStatus('Sending');
    try {
      var res = await fetch(API + '/request', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ kind: 'quote', name: name, email: email, phone: fd.get('phone'), message: fd.get('message') || '', piece: S.piece || null, marketing_consent: !!fd.get('marketing_consent'), website: fd.get('website') || '', turnstile: S.turnstile || '' }) });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok || !data.ok) { btn.disabled = false; setStatus(data.error || 'We could not send your request. Please try again.', true); return; }
      setHead('Thank you', '');
      setStatus('');
      body.innerHTML =
        '<div class="alb-book__summary"><b>Request received</b>' + (S.piece && S.piece.title ? esc(S.piece.title) + '<br>' : '') + 'Reference #' + esc(data.ticket_no) + '</div>' +
        '<p style="margin:0;font-size:14px;line-height:22px">We will come back to ' + esc(email) + ' with a price and a timeline within one business day.</p>' +
        '<button type="button" class="alb-book__btn alb-book__btn--alt" data-book-close>Done</button>';
      body.querySelector('[data-book-close]').focus();
    } catch (e) {
      btn.disabled = false;
      setStatus('We could not reach the studio. Please try again or email info@albisia.com.', true);
    }
  }

  // ---------------- plan a Sparked party ----------------
  // Opens from data-albisia-book="party" (data-party-package carries the package name, data-party-occasion preselects the occasion). The occasion and upgrade lists come
  // from the Sparked parties section on the page when it is there, so the editor's blocks drive the popup too.
  var PARTY_OCC = ['Bachelorette and bridal', 'Birthdays', 'Mothers and daughters', 'Sorority chapters', 'Corporate teams'];
  var PARTY_UP = ['The Morning Bar', 'The Golden Hour', 'The Soirée', 'The Company Logo Charm'];
  var partyLists = function () {
    var sec = document.querySelector('[data-alb-parties]');
    var read = function (attr, dflt) { var v = sec ? (sec.getAttribute(attr) || '') : ''; var list = v.split('|').map(function (s) { return s.trim(); }).filter(Boolean); return list.length ? list : dflt; };
    return { occasions: read('data-occasions', PARTY_OCC), upgrades: read('data-upgrades', PARTY_UP) };
  };
  var partyMonths = {};
  var chips = function (name, type, items, checked) {
    return '<div class="alb-book__chips">' + items.map(function (it) {
      return '<label class="alb-book__chip"><input type="' + type + '" name="' + name + '" value="' + esc(it) + '"' + (it === checked ? ' checked' : '') + '><span>' + esc(it) + '</span></label>';
    }).join('') + '</div>';
  };
  function showParty(pkg, occasion) {
    S.party_pkg = pkg || '';
    var L = partyLists();
    var occ0 = occasion && L.occasions.indexOf(occasion) > -1 ? occasion : '';
    var time0 = /after hours/i.test(S.party_pkg) ? 'After hours' : 'Afternoon';
    var today = todayTampa();
    var max = new Date(); max.setMonth(max.getMonth() + 6); max = max.toISOString().slice(0, 10);
    setHead('Plan a Sparked party', (S.party_pkg ? S.party_pkg + '. ' : '') + 'Tell us about the day and we confirm the time within one business day. Nothing to pay now.');
    body.innerHTML =
      '<form data-party-form novalidate>' +
        '<label id="alb-pocc-l">The occasion (required)</label>' + chips('occasion', 'radio', L.occasions.concat(['Something else']), occ0) +
        '<label for="alb-pguests">How many guests (required)</label><input class="alb-book__field" id="alb-pguests" name="guests" type="number" min="2" max="60" inputmode="numeric" placeholder="Five or more" required>' +
        '<div class="alb-book__row2">' +
          '<div><label for="alb-pdate">Preferred date (required)</label><input class="alb-book__field" id="alb-pdate" name="date" type="date" min="' + today + '" max="' + max + '" required><p class="alb-book__avail" data-party-avail aria-live="polite"></p></div>' +
          '<div><label for="alb-pdate2">Second choice</label><input class="alb-book__field" id="alb-pdate2" name="date2" type="date" min="' + today + '" max="' + max + '"></div>' +
        '</div>' +
        '<label id="alb-ptime-l">Preferred time</label>' + chips('time', 'radio', ['Morning', 'Afternoon', 'Evening', 'After hours'], time0) +
        '<p class="alb-book__avail" data-party-ah' + (time0 === 'After hours' ? '' : ' hidden') + '>Private evening, the store closed to everyone but your party. Monday to Saturday from 8 pm, Sunday from 5 pm. Eight guests or more.</p>' +
        (L.upgrades.length ? '<label id="alb-pup-l">Add to the afternoon (optional)</label>' + chips('upgrades', 'checkbox', L.upgrades, '') : '') +
        '<div class="alb-book__row2">' +
          '<div><label for="alb-pname">Your name (required)</label><input class="alb-book__field" id="alb-pname" name="name" type="text" autocomplete="name" required></div>' +
          '<div><label for="alb-pemail">Email (required)</label><input class="alb-book__field" id="alb-pemail" name="email" type="email" autocomplete="email" inputmode="email" required></div>' +
        '</div>' +
        '<div class="alb-book__row2">' +
          '<div><label for="alb-pphone">Phone (required)</label><input class="alb-book__field" id="alb-pphone" name="phone" type="tel" autocomplete="tel" inputmode="tel" required></div>' +
          '<div><label for="alb-pgroup">Company or group name</label><input class="alb-book__field" id="alb-pgroup" name="group" type="text" placeholder="For a team or a chapter"></div>' +
        '</div>' +
        '<label for="alb-pmsg">Anything we should know? (optional)</label><textarea class="alb-book__field" id="alb-pmsg" name="message" rows="3" maxlength="2000" placeholder="Who the party is for, a theme, a logo charm, a note for the table"></textarea>' +
        '<div class="alb-book__hp" aria-hidden="true"><label for="alb-pwebsite">Website</label><input id="alb-pwebsite" name="website" type="text" tabindex="-1" autocomplete="off"></div>' +
        '<label class="alb-book__check"><input type="checkbox" name="marketing_consent"> Send me new pieces and studio news by email (optional)</label>' +
        (TS_KEY ? '<div class="alb-book__turnstile" id="alb-turnstile" style="margin-top:14px"></div>' : '') +
        '<button type="submit" class="alb-book__btn">Send the request</button>' +
      '</form>' +
      '<p class="alb-book__fine">The session is free to book. Each guest chooses and pays for their own piece on the day, or the host covers the table.</p>';
    var first = body.querySelector('input[name="occasion"]'); if (first) first.focus();
    if (TS_KEY) mountTurnstile();
    var form = body.querySelector('[data-party-form]');
    form.querySelector('#alb-pdate').addEventListener('change', function () { partyAvail(form); });
    form.querySelectorAll('input[name="time"]').forEach(function (r) { r.addEventListener('change', function () { form.querySelector('[data-party-ah]').hidden = !partyAfterHours(form); partyAvail(form); }); });
  }
  var partyAfterHours = function (form) { var t = form.querySelector('input[name="time"]:checked'); return !!(t && t.value === 'After hours'); };
  // One look at the Sparked calendar for the chosen day, so the request lands realistic.
  async function partyAvail(form) {
    var el = form.querySelector('[data-party-avail]');
    var ds = form.querySelector('#alb-pdate').value;
    el.className = 'alb-book__avail';
    if (!ds) { el.textContent = ''; return; }
    if (partyAfterHours(form)) { el.textContent = 'After hours is by request. We confirm the evening with you directly.'; return; }
    var mk = ds.slice(0, 7);
    el.textContent = 'Checking the studio calendar';
    try {
      if (!partyMonths[mk]) { var d = await api('/availability?service=sparked&month=' + mk); partyMonths[mk] = d.days || []; }
      if (form.querySelector('#alb-pdate').value !== ds) return;
      var open = partyMonths[mk].indexOf(ds) > -1;
      el.className = 'alb-book__avail ' + (open ? 'is-open' : 'is-full');
      el.textContent = open ? 'The studio has openings that day. We confirm the exact time with you.' : 'That day is full on the studio calendar. Add a second choice or ask about an evening session; we confirm what is possible.';
    } catch (e) { el.textContent = ''; }
  }
  async function submitParty(form) {
    var btn = form.querySelector('button[type="submit"]');
    var fd = new FormData(form);
    var v = function (k) { return String(fd.get(k) || '').trim(); };
    var occ = v('occasion'), guests = parseInt(v('guests') || '0', 10), date = v('date'), name = v('name'), email = v('email'), phone = v('phone');
    if (!occ) { setStatus('Tell us the occasion first.', true); form.querySelector('input[name="occasion"]').focus(); return; }
    if (!guests || guests < 2) { setStatus('How many guests are coming? Two or more for a group.', true); form.querySelector('#alb-pguests').focus(); return; }
    if (partyAfterHours(form) && guests < 8) { setStatus('After hours is for eight guests or more. For a smaller group choose a daytime session.', true); form.querySelector('#alb-pguests').focus(); return; }
    if (!date) { setStatus('Pick a preferred date.', true); form.querySelector('#alb-pdate').focus(); return; }
    if (!name) { setStatus('Please fill in your name.', true); form.querySelector('#alb-pname').focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setStatus('Please enter a valid email.', true); form.querySelector('#alb-pemail').focus(); return; }
    if (!phone) { setStatus('A phone number, so we can confirm the day quickly.', true); form.querySelector('#alb-pphone').focus(); return; }
    if (TS_KEY && !S.turnstile) { setStatus('One moment, checking you are not a robot.', true); setTimeout(function () { if (S.turnstile) submitParty(form); }, 1500); return; }
    var avail = form.querySelector('[data-party-avail]');
    var details = { 'Occasion': occ, 'Guests': String(guests), 'Where': 'At the studio, Hyde Park Village', 'Preferred date': date, 'Preferred time': v('time') || 'Afternoon' };
    if (v('date2')) details['Second date'] = v('date2');
    var ups = fd.getAll('upgrades').map(String).filter(Boolean); if (ups.length) details['Upgrades'] = ups.join(', ');
    if (v('group')) details['Group name'] = v('group');
    if (S.party_pkg) details['Package'] = S.party_pkg;
    if (avail.classList.contains('is-open')) details['Studio calendar'] = 'Open on the preferred date';
    if (avail.classList.contains('is-full')) details['Studio calendar'] = 'Full on the preferred date';
    details['Page'] = location.pathname;
    btn.disabled = true; setStatus('Sending');
    try {
      var res = await fetch(API + '/request', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ kind: 'party', name: name, email: email, phone: phone, message: v('message'), details: details, marketing_consent: !!fd.get('marketing_consent'), website: fd.get('website') || '', turnstile: S.turnstile || '' }) });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok || !data.ok) { btn.disabled = false; setStatus(data.error || 'We could not send your request. Please try again.', true); return; }
      adsConversion(GADS_BOOKED, { transaction_id: 'party-' + String(data.ticket_no || ''), value: 75, currency: 'USD' });
      setHead('Thank you, ' + name.split(' ')[0], '');
      setStatus('');
      body.innerHTML =
        '<div class="alb-book__summary"><b>Party request received</b>' + esc(occ) + ' · ' + guests + ' guests · ' + esc(fmtDate(date + 'T12:00:00-04:00')) + (S.party_pkg ? '<br>' + esc(S.party_pkg) : '') + '<br>Reference #' + esc(data.ticket_no) + '</div>' +
        '<p style="margin:0;font-size:14px;line-height:22px">We confirm the date and time with ' + esc(email) + ' within one business day, and we call if the day needs a second look. Nothing to pay now; each guest chooses their chain on the day.</p>' +
        '<button type="button" class="alb-book__btn alb-book__btn--alt" data-book-close>Done</button>';
      body.querySelector('[data-book-close]').focus();
    } catch (e) {
      btn.disabled = false;
      setStatus('We could not reach the studio. Please try again or email info@albisia.com.', true);
    }
  }

  // Google Ads: a booking is the conversion this site is measured by (action "Book appointment", value 75 USD, once per click).
  var GADS_BOOKED = 'AW-1012999940/ff7JCJW7h_scEITOhOMD';
  function adsConversion(sendTo, extra) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'conversion', Object.assign({ send_to: sendTo }, extra || {})); } catch (e) {}
  }

  function showDone(data, email) {
    var b = data.booking || {};
    adsConversion(GADS_BOOKED, { transaction_id: String(b.order || b.id || ''), value: 75, currency: 'USD' });
    setHead('You are booked', '');
    setStatus('');
    body.innerHTML =
      '<div class="alb-book__summary"><b>' + esc(b.service || S.service.name) + '</b>' + esc(b.date || fmtDate(S.slot.start)) + ' at ' + esc(b.time || fmtTime(S.slot.start)) + (b.party > 1 ? ' for ' + b.party + ' people' : '') + '<br>' +
        (b.location_type === 'video' ? 'By video. The link comes in your confirmation email.' : esc(b.address || ADDRESS)) + '</div>' +
      '<p style="margin:0;font-size:14px;line-height:22px">A confirmation is on its way to ' + esc(email) + '. If you need to cancel, use the link in that email.</p>' +
      (b.notes ? '<p class="alb-book__fine">' + esc(b.notes) + '</p>' : '') +
      (data.ics_url ? '<a class="alb-book__btn" href="' + esc(data.ics_url) + '">Add to calendar</a>' : '') +
      '<button type="button" class="alb-book__btn alb-book__btn--alt" data-book-close>Done</button>';
    body.querySelector('[data-book-close]').focus();
  }

  function showFallback() {
    setHead('Book an appointment', '');
    setStatus('');
    body.innerHTML =
      '<p style="margin:0 0 14px;font-size:14px;line-height:22px">Online booking is unavailable right now. We can book you by email or phone.</p>' +
      '<a class="alb-book__btn" href="mailto:info@albisia.com?subject=' + encodeURIComponent('Appointment request') + '">Email info@albisia.com</a>' +
      '<a class="alb-book__btn alb-book__btn--alt" href="tel:+18135052611">Call (813) 505-2611</a>' +
      '<p class="alb-book__fine">' + esc(ADDRESS) + '. Monday to Saturday 10 to 8, Sunday 12 to 5.</p>';
    body.querySelector('a').focus();
  }

  // ---------------- events ----------------
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-book-close], [data-pick-service], [data-month], [data-day], [data-slot], [data-back], [data-party]');
    if (!t) return;
    if (t.hasAttribute('data-book-close')) { close(); return; }
    if (t.hasAttribute('data-pick-service')) {
      if (t.getAttribute('data-pick-service') === '__party') { S.mode = 'party'; panel.classList.add('alb-book__panel--wide'); setStatus(''); showParty('', ''); return; }
      S.service = S.services.find(function (s) { return s.key === t.getAttribute('data-pick-service'); }); S.month = null; S.date = null; S.party = 1; showDates(); return; }
    if (t.hasAttribute('data-month')) { if (t.disabled) return; var y = +S.month.slice(0, 4), m = +S.month.slice(5, 7) + (+t.getAttribute('data-month')); var d = new Date(Date.UTC(y, m - 1, 1)); showDates(d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1)); return; }
    if (t.hasAttribute('data-day')) { if (t.disabled) return; showTimes(t.getAttribute('data-day')); return; }
    if (t.hasAttribute('data-party')) { S.party = +t.getAttribute('data-party'); showTimes(S.date); return; }
    if (t.hasAttribute('data-slot')) { showDetails(t.getAttribute('data-slot')); return; }
    if (t.hasAttribute('data-back')) { var b = t.getAttribute('data-back'); if (b === 'services') showServices(); else if (b === 'dates') showDates(S.month); else if (b === 'times') showTimes(S.date); }
  });
  root.addEventListener('submit', function (e) { var p = e.target.closest('[data-party-form]'); if (p) { e.preventDefault(); submitParty(p); return; } var q = e.target.closest('[data-quote-form]'); if (q) { e.preventDefault(); submitQuote(q); return; } var f = e.target.closest('[data-book-form]'); if (!f) return; e.preventDefault(); submit(f); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), a[href], input:not([tabindex="-1"]), select, textarea');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      return;
    }
    var day = e.target.closest && e.target.closest('.alb-book__day');
    if (day && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) > -1) {
      e.preventDefault();
      var all = Array.prototype.slice.call(body.querySelectorAll('.alb-book__day:not(.is-empty)'));
      var i = all.indexOf(day);
      var step = e.key === 'ArrowLeft' ? -1 : e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' ? -7 : 7;
      var j = i + step;
      while (j >= 0 && j < all.length && all[j].disabled) j += (step > 0 ? 1 : -1);
      if (all[j]) all[j].focus();
    }
  });

  // Triggers on the page
  document.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-albisia-quote]');
    if (qb) { e.preventDefault(); e.stopPropagation(); open({ mode: 'quote', piece: pieceFromPage() }); return; }
    var t = e.target.closest('[data-albisia-book], [data-albisia-book-variant]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      if (t.getAttribute('data-albisia-book') === 'party') { open({ mode: 'party', pkg: t.getAttribute('data-party-package') || '', occasion: t.getAttribute('data-party-occasion') || '' }); return; }
      if (t.getAttribute('data-albisia-book') === 'appointment') { open({ service: null, only: ['showroom', 'virtual'], piece: pieceFromPage() }); return; }
      if (t.hasAttribute('data-albisia-book-variant')) {
        var formId = t.getAttribute('data-product-form');
        var sel = formId ? document.querySelector('#' + CSS.escape(formId) + ' [name="id"]') : document.querySelector('form[action*="/cart/add"] [name="id"]');
        open({ variantId: sel ? sel.value : t.getAttribute('data-albisia-book-variant') });
      } else {
        open({ service: t.getAttribute('data-albisia-book') || null });
      }
      return;
    }
    if (!LIVE) return;
    var pl = e.target.closest('a[href$="#book-party"]'); if (pl) { e.preventDefault(); e.stopPropagation(); open({ mode: 'party' }); return; }
    var a = e.target.closest('a[href$="#albisia-book-sparked"], a[href$="#albisia-book-repair"], a[href$="#albisia-book-showroom"], a[href$="#albisia-book-virtual"], a[href$="#albisia-book-appointment"], a[href$="#book-sparked"], a[href$="#book-repair"], a[href$="#book-showroom"], a[href$="#book-virtual"], a[href$="#book-appointment"], [data-alb-appointments]');
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    var href = a.getAttribute('href') || '';
    var m = href.match(/#(?:albisia-)?book-(sparked|repair|showroom|virtual)$/);
    open({ service: m ? m[1] : null });
  }, true);

  // Product pages of bookable services: booking details replace price and stock, our button replaces the buy button.
  var BOOKING_HANDLES = ['sparked-jewelry', 'appointment-with-albisia-custom-jewelry-design'];
  function selectedVariantId(sec) {
    var sel = sec.querySelector('form[action*="/cart/add"] [name="id"]');
    if (sel && sel.value) return sel.value;
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function renderProductInfo(sec) {
    var info = sec.querySelector('[data-booking-info]');
    if (!info) return;
    loadServices().then(function (services) {
      var vid = selectedVariantId(sec);
      var svc = services.find(function (s) { return String(s.shopify_variant_id) === String(vid); }) || services.find(function (s) { return String(s.shopify_product_id) === String(sec.getAttribute('data-product-id') || ''); });
      if (!svc) { info.hidden = true; return; }
      var where = svc.location_type === 'video' ? 'By video, wherever you are' : svc.location_type === 'phone' ? 'By phone' : 'At the studio, Hyde Park Village';
      info.hidden = false;
      info.innerHTML = '<b>' + esc(svc.name) + '</b>' + svc.duration_min + ' minutes · ' + esc(where) + ' · No charge to book' + (svc.description ? '<br>' + esc(svc.description) : '');
    }).catch(function () { info.hidden = true; });
  }
  function mountProductButton() {
    var sec = document.querySelector('.product-section[data-product-handle]');
    if (!sec || BOOKING_HANDLES.indexOf(sec.getAttribute('data-product-handle')) < 0) return;
    if (sec.querySelector('[data-albisia-book-variant]')) return;
    var form = sec.querySelector('form[action*="/cart/add"]');
    var block = form ? form.closest('.product-block') : null;
    var priceBlock = sec.querySelector('.product-block--price');
    var info = document.createElement('div');
    info.className = 'albisia-booking-info'; info.setAttribute('data-booking-info', ''); info.hidden = true;
    if (priceBlock) priceBlock.insertAdjacentElement('afterend', info); else if (block) block.insertAdjacentElement('beforebegin', info);
    renderProductInfo(sec);
    sec.addEventListener('change', function () { setTimeout(function () { renderProductInfo(sec); }, 50); });
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'btn btn--full'; btn.textContent = 'Book a time';
    btn.setAttribute('data-albisia-book-variant', '');
    if (form && form.getAttribute('id')) btn.setAttribute('data-product-form', form.getAttribute('id'));
    var note = document.createElement('p');
    note.style.cssText = 'margin:10px 0 0;font-size:.85em;';
    note.textContent = 'Pick a day and a time. Your confirmation arrives by email.';
    if (block) { block.insertAdjacentElement('afterend', note); block.insertAdjacentElement('afterend', btn); }
    else { var holder = sec.querySelector('[data-product-blocks]') || sec; holder.appendChild(btn); holder.appendChild(note); }
    if (sec.getAttribute('data-product-handle') === 'sparked-jewelry') {
      var pl = document.createElement('p'); pl.style.cssText = 'margin:14px 0 0;font-size:.85em;';
      pl.innerHTML = 'Five or more? <a href="/pages/sparked-parties#book-party" style="text-decoration:underline;text-underline-offset:3px">Plan a party</a>';
      note.insertAdjacentElement('afterend', pl);
    }
  }
  mountProductButton();
  document.addEventListener('shopify:section:load', mountProductButton);

  // Fine pieces with nothing in stock: "Made to order" with a quote and an appointment, where the price and cart were.
  function mountMadeToOrder() {
    var tag = document.querySelector('[data-albisia-piece][data-mto="true"]');
    var sec = document.querySelector('.product-section[data-product-handle]');
    if (!tag || !sec || sec.querySelector('.albisia-mto')) return;
    var box = document.createElement('div');
    box.className = 'albisia-mto';
    box.innerHTML = '<b>Made to order</b><p>Made in the studio to your order. Gold and stone prices move daily, so we quote each piece fresh and tell you the timeline with it.</p>' +
      '<button type="button" class="btn btn--full" data-albisia-quote>Request a quote</button>' +
      '<button type="button" class="btn btn--full btn--secondary" data-albisia-book="appointment">Book an appointment</button>';
    var priceBlock = sec.querySelector('.product-block--price');
    var form = sec.querySelector('form[action*="/cart/add"]');
    var block = form ? form.closest('.product-block') : null;
    if (priceBlock) priceBlock.insertAdjacentElement('afterend', box); else if (block) block.insertAdjacentElement('beforebegin', box); else (sec.querySelector('[data-product-blocks]') || sec).appendChild(box);
  }
  mountMadeToOrder();
  document.addEventListener('shopify:section:load', mountMadeToOrder);

  // One of a kind: the line moves under the price.
  function mountOneOfAKind() {
    var src = document.querySelector('[data-albisia-ooak]');
    var sec = document.querySelector('.product-section[data-product-handle]');
    if (!src || !sec || sec.querySelector('.albisia-ooak')) return;
    var box = document.createElement('div'); box.className = 'albisia-ooak'; box.innerHTML = src.innerHTML;
    var priceBlock = sec.querySelector('.product-block--price');
    if (priceBlock) priceBlock.insertAdjacentElement('afterend', box); else (sec.querySelector('[data-product-blocks]') || sec).appendChild(box);
  }
  mountOneOfAKind();
  document.addEventListener('shopify:section:load', mountOneOfAKind);

  // Live mode: the announcement bar's own menu must not open. Its button listeners are attached directly,
  // so replacing the buttons drops them; its link handler matches #book-* hrefs, so those get a new hash.
  function takeOverHooks() {
    if (!LIVE) return;
    document.querySelectorAll('[data-alb-appointments]').forEach(function (b) { if (b.dataset.albisiaTaken) return; var c = b.cloneNode(true); c.dataset.albisiaTaken = '1'; b.parentNode.replaceChild(c, b); });
    document.querySelectorAll('a[href$="#book-sparked"], a[href$="#book-repair"], a[href$="#book-showroom"], a[href$="#book-virtual"], a[href$="#book-appointment"]').forEach(function (a) {
      a.setAttribute('href', a.getAttribute('href').replace(/#book-(sparked|repair|showroom|virtual|appointment)$/, '#albisia-book-$1'));
    });
  }
  takeOverHooks();
  document.addEventListener('shopify:section:load', takeOverHooks);
  if (LIVE || document.querySelector('[data-albisia-book-variant]')) {
    if (document.readyState === 'complete') setTimeout(warm, 1200); else window.addEventListener('load', function () { setTimeout(warm, 1200); });
  }

  window.AlbisiaBooking = { open: open, close: close, live: LIVE };
})();

